<template>
  <div class="list-container">
    <div class="top-fix-area" ref="topFixArea">
      <h1 class="page-title">ユーザマスタ一覧</h1>
      <div class="mb-2">
      <router-link
        v-if="userRole == 0 || userRole == 999"
        :to="{ path: '/create-user', query: getSearchQuery() }"
        class="btn btn-sm btn-primary me-2"
      >
        ユーザマスタ作成
      </router-link> <!-- ユーザマスタ作成ページへのリンク -->

        <!-- Button trigger modal -->
        <button v-if="userRole == 999" type="button" class="btn btn-sm btn-primary me-2" data-bs-toggle="modal" data-bs-target="#exampleModal">
          CSVインポート
        </button>
  
        <!-- Button trigger modal -->
        <button type="button" class="btn btn-sm btn-primary me-2" @click="downloadCsv">CSVエクスポート</button>

        <button class="btn btn-sm btn-outline-secondary" @click="isSearchExpanded = !isSearchExpanded">
          {{ isSearchExpanded ? '検索条件を非表示' : '検索条件を表示' }}
        </button>
      </div>

      <!-- Modal -->
      <div class="modal fade" id="exampleModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <h1 class="modal-title fs-5" id="exampleModalLabel">CSVインポート</h1>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" @click="clearErrorMessages"></button>
            </div>
            <div class="modal-body">
              <div v-if="errorMessages" >
                <div class="error-massage-item" v-for="errorMessage in errorMessages" :key="errorMessage.id">
                  <p class="alert alert-danger mt-2">{{ errorMessage.row_num }}行目：{{errorMessage.messages[0]}}</p>
                </div>
              </div>

              <div class="my-3">
                <p>ユーザ情報CSVファイル選択</p>
                <input type="file" class="form-control" @change="handleFileChange">
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-sm btn-secondary" data-bs-dismiss="modal" @click="clearErrorMessages">閉じる</button>
              <button type="button" class="btn btn-sm btn-primary" @click="submitFile">インポート</button>
            </div>
          </div>
        </div>
      </div>

      <!-- 検索バーの追加 -->
      <SearchPanelWrapper :key="route.fullPath" v-model="isSearchExpanded" :getTableElement="() => tableWrapper?.$el || tableWrapper?.value" >
        <form class="search-container" style="background-color: #f8f9fa;" @submit.prevent="searchUsers"> <!-- 背景色を薄く設定 -->
          <div class="row g-3 align-items-center">
            <div class="col-auto">
              <label for="searchName" class="col-form-label">ユーザ名</label>
            </div>
            <div class="col-auto">
              <input type="text" id="searchName" class="form-control" v-model="searchName" placeholder="ユーザ名で検索">
            </div>

            <div class="col-auto">
              <label for="searchEmail" class="col-form-label">メールアドレス</label>
            </div>
            <div class="col-auto">
              <input type="text" id="searchEmail" class="form-control" v-model="searchEmail" placeholder="メールアドレスで検索">
            </div>

            <DeletedStatusSelect v-model="searchDeletedStatus" id="userDeletedStatus" />

            <div class="col-auto">
              <button type="submit" class="btn btn-primary">検索</button>
              <button type="button" class="btn btn-secondary mx-1" @click="searchResetUsers">クリア</button>
            </div>
          </div>
        </form>
      </SearchPanelWrapper>
    </div>

    <div class="d-flex justify-content-end" ref="paginationContainer">
      <Pagination
        :currentPage="currentPage"
        :totalPages="totalPages"
        @change-page="handleChangePage"
      />
    </div>

    <div class="table-wrapper" ref="tableWrapper">
      <table class="master-table table table-bordered">
        <thead class="table-dark">
          <tr>
            <th class="text-nowrap">ID</th>
            <th class="text-nowrap">ユーザ名</th>
            <th class="text-nowrap">メールアドレス</th>
            <th class="text-nowrap">現在システム権限</th>
            <th class="text-nowrap">システム別権限</th>
            <th class="btn-cell"></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="user in users" :key="user.id" :class="{ 'no-active-user': user.del_flg == 1 }">
            <td>{{ user.id }}</td>
            <td>{{ user.name }}</td>
            <td>{{ user.email }}</td>
            <td>{{ roleLabel(user.role) }}</td>
            <td>
              <div v-for="clientSystem in clientSystems" :key="`${user.id}-${clientSystem.key}`">
                {{ clientSystem.label }}: {{ roleLabel(user.roles_by_system?.[clientSystem.key]) }}
              </div>
            </td>
            <td class="btn-cell text-nowrap">
              <button v-if="userRole == 0 || userRole == 999" class="btn btn-sm btn-success me-2" data-bs-toggle="modal" data-bs-target="#passwordUpdateModal" @click="handlePasswordUpdateClick(user.id)">パスワード更新</button>

              <router-link :to="{ name: 'UserDetail', params: { id: user.id }, query: getSearchQuery() }"> <!-- 顧客情報詳細ページへのリンク -->
                <button type="button" class="btn btn-sm btn-info me-2">詳細</button>
              </router-link>

              <router-link v-if="userRole == 0 || userRole == 999" :to="{ name: 'UserEdit', params: { id: user.id }, query: getSearchQuery() }"> <!-- 顧客情報編集ページへのリンク -->
                <button type="button" class="btn btn-sm btn-success me-2">編集</button>
              </router-link>

              <button v-if="user.del_flg == 0 && (userRole == 0 || userRole == 999)" class="btn btn-sm btn-danger" data-bs-toggle="modal" data-bs-target="#deleteModal" @click="handleDeleteClick(user.id)">削除</button>
              <button v-if="user.del_flg == 1 && (userRole == 0 || userRole == 999)" class="btn btn-sm btn-warning" data-bs-toggle="modal" data-bs-target="#restoreModal" @click="handleRestoreClick(user.id)">復元</button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    
    <!-- 削除確認モーダル -->
    <PasswordResetModal
      :userId="paramsIdToPasswordUpdate"
    />

    <!-- 削除確認モーダル -->
    <DeleteConfirmationModal
      :paramsId="paramsIdToDelete"
      @confirmDelete="handleConfirmDelete"
    />

    <!-- 復元確認モーダル -->
    <RestoreConfirmationModal
      :paramsId="paramsIdToRestore"
      @confirmRestore="handleConfirmRestore"
    />
  </div>
</template>

<script>
import { ref, computed, onMounted, watchEffect } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import { useRoute } from 'vue-router';
import {
  getUsers,
  getUserRoleCatalog,
  deleteUser,
  restoreUser,
  exportUsersCsv,
  importUsersCsv
} from '@/api/axios';
import { Modal } from 'bootstrap';
import SearchPanelWrapper from '@/components/searchPanels/SearchPanelWrapper.vue';
import PasswordResetModal from '@/components/shared/PasswordResetModal.vue';
import DeleteConfirmationModal from '@/components/shared/DeleteConfirmationModal.vue';
import RestoreConfirmationModal from '@/components/shared/RestoreConfirmationModal.vue';
import Pagination from '@/components/shared/Pagination.vue';
import DeletedStatusSelect from '@/components/shared/DeletedStatusSelect.vue';

export default {
  components: {
    SearchPanelWrapper,
    PasswordResetModal,
    DeleteConfirmationModal,
    RestoreConfirmationModal,
    Pagination,
    DeletedStatusSelect
  },
  setup() {
    const title = ref('ユーザ一覧');

    watchEffect(() => {
      document.title = title.value;
    });
    

    const store = useStore();
    const router = useRouter();
    const route = useRoute();
    const userRole = computed(() => store.state.userRole);
    const users = ref([]);
    const selectedFile = ref(null);

    // エラーメッセージ用のリアクティブプロパティ
    const errorMessages = ref({});

    // モーダルへ渡すID
    const paramsIdToPasswordUpdate = ref(null);
    const paramsIdToDelete = ref(null);
    const paramsIdToRestore = ref(null);

    // 検索用のデータプロパティ
    const searchName = ref('');
    const searchEmail = ref('');
    const searchDeletedStatus = ref('active');
    const clientSystems = ref([]);
    const roleOptions = ref([]);

    // テーブルの高さの動的な設定
    const topFixArea = ref(null);
    const tableWrapper = ref(null);
    const paginationContainer = ref(null);

    // 検索パネルの展開状態を管理するためのリアクティブプロパティ
    const isSearchExpanded = ref(true);

    // ▼▼ 共通：検索条件をそのまま query として返す ▼▼
    const getSearchQuery = () => ({
      user_name: searchName.value,
      user_email: searchEmail.value,
      user_deleted_status: searchDeletedStatus.value,
      user_page: currentPage.value || 1
    });

    const roleLabel = (roleValue) => {
      const roleOption = roleOptions.value.find((option) => Number(option.value) === Number(roleValue));
      return roleOption?.label || roleValue || '-';
    };

    // ページネーション
    const currentPage = ref(1);
    const totalPages = ref(20); // トータルページ数を管理するためのプロパティ

    const fetchUsers = async (page = 1) => {
      try {
        const response = await getUsers({
          name: searchName.value,
          email: searchEmail.value,
          deleted_status: searchDeletedStatus.value,
          page: page
        });
        users.value = response.data.users;
        totalPages.value = response.data.meta.total_pages;
        currentPage.value = response.data.meta.current_page;
        clientSystems.value = response.data.meta?.client_systems || clientSystems.value;
        roleOptions.value = response.data.meta?.role_options || roleOptions.value;
      } catch (error) {
        console.error('建物種別情報ーデータの取得に失敗しました:', error);
      }
    };

    const fetchRoleCatalog = async () => {
      try {
        const response = await getUserRoleCatalog();
        clientSystems.value = response.data.client_systems || clientSystems.value;
        roleOptions.value = response.data.role_options || roleOptions.value;
      } catch (error) {
        console.error('権限マスタ情報の取得に失敗しました:', error);
      }
    };

    const handleChangePage = (page) => {
      if (page >= 1 && page <= totalPages.value) {
        fetchUsers(page);

        const q = getSearchQuery();
        q.user_page = page;

        router.replace({
          path: '/users',
          query: q
        });

        // スクロールを tableWrapper のトップへ
        if (tableWrapper.value) {
          tableWrapper.value.scrollTop = 0;
        }
      }
    };
    
    // パスワード更新
    const handlePasswordUpdateClick = (userId) => {
      paramsIdToPasswordUpdate.value = userId;
    };
    
    // ユーザ削除
    const handleDeleteClick = (userId) => {
      paramsIdToDelete.value = userId;
    };

    const handleRestoreClick = (userId) => {
      paramsIdToRestore.value = userId;
    };
    
    const handleConfirmDelete = async (userId) => {
      try {
        await deleteUser(userId);
        store.dispatch('setFlashMessage', { message: 'ユーザーが削除されました', type: 'success' });
        await fetchUsers(currentPage.value);
      } catch (error) {
        // エラー処理
        store.dispatch('setFlashMessage', { message: 'ユーザ情報削除に失敗しました', type: 'danger' });
      }
    };

    const handleConfirmRestore = async (userId) => {
      try {
        await restoreUser(userId);
        store.dispatch('setFlashMessage', { message: 'ユーザーが復元されました', type: 'success' });
        await fetchUsers(currentPage.value);
      } catch (error) {
        store.dispatch('setFlashMessage', { message: 'ユーザ情報復元に失敗しました', type: 'danger' });
      }
    };

    // CSVエクスポート
    const downloadCsv = async () => {
      try {
        const response = await exportUsersCsv({
          name: searchName.value,
          email: searchEmail.value,
          deleted_status: searchDeletedStatus.value
        });

        // 現在の年月日時分秒を取得してフォーマット
        const now = new Date();
        const timestamp = `${now.getFullYear()}${(now.getMonth() + 1).toString().padStart(2, "0")}${now.getDate().toString().padStart(2, "0")}_${now.getHours().toString().padStart(2, "0")}${now.getMinutes().toString().padStart(2, "0")}${now.getSeconds().toString().padStart(2, "0")}`;

        const fileName = `users_${timestamp}.csv`; // 動的なファイル名

        // CSVファイルをダウンロード
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch (error) {
        console.error("CSVダウンロードエラー", error);
      }
    };

    // CSVインポート
    const handleFileChange = (event) => {
      selectedFile.value = event.target.files[0]; // 選択されたファイルを保存
    };

    // モーダルを閉じる処理
    const closeModal = () => {
      const modalElement = document.getElementById('exampleModal');
      const modal = Modal.getInstance(modalElement) || new Modal(modalElement);
      modal.hide();
    };

    // モーダルが閉じた後に実行される処理
    const onModalHidden = () => {
      clearErrorMessages(); // エラーメッセージをクリアする関数を呼び出す
    };

    // モーダルの閉じるボタンのアクション
    const clearErrorMessages = () => {
      errorMessages.value = {}; // エラーメッセージをクリア
      selectedFile.value = null; // ファイルをクリア

      // inputタグのvalueをリセット
      const input = document.querySelector('.form-control[type="file"]');
      if (input) {
        input.value = '';
      }
    };

    const submitFile = async () => {
      if (!selectedFile.value) {
        store.dispatch('setFlashMessage', { message: 'ファイルが選択されていません', type: 'danger' });
        return;
      }

      try {
        await importUsersCsv(selectedFile.value); // 選択されたファイルを関数に渡す
        store.dispatch('setFlashMessage', { message: 'アップロードに成功しました', type: 'success' });
        // モーダルを閉じる
        closeModal();

        // モーダルが完全に閉じた後に実行されるイベントリスナーを追加
        document.getElementById('exampleModal').addEventListener('hidden.bs.modal', onModalHidden);

        // ユーザ情報の再取得
        await fetchUsers();
      } catch (error) {
        if (error.response && error.response.data) {
          // エラーメッセージをerrorMessagesにセット
          errorMessages.value = error.response.data || {};
        }
        console.error('アップロードに失敗しました', error);
        store.dispatch('setFlashMessage', { message: 'アップロードに失敗しました', type: 'danger' });
      }
    };

    // ユーザを検索するメソッド
    const searchUsers = async () => {
      await fetchUsers(1);

      const q = getSearchQuery();
      q.user_page = 1;

      router.push({
        path: '/users',
        query: q
      });
    };
    
    // ユーザを検索リセットするメソッド
    const searchResetUsers = async () => {
      searchName.value = ''; // 名前検索条件をクリア
      searchEmail.value = ''; // メールアドレス検索条件をクリア
      searchDeletedStatus.value = 'active';

      await fetchUsers(1);

      const q = getSearchQuery();
      q.user_page = 1;

      router.replace({
        path: '/users',
        query: q
      });
    };

    // ▼▼▼ クエリパラメータから検索条件を復元 ▼▼▼
    onMounted(async () => {
      const q = route.query;

      searchName.value = q.user_name || '';
      searchEmail.value = q.user_email || '';
      searchDeletedStatus.value = q.user_deleted_status || 'active';
      currentPage.value = q.user_page ? Number(q.user_page) : 1;

      await fetchRoleCatalog();
      await fetchUsers(currentPage.value);
    });

    return {
      title,
      route,
      userRole,
      users,
      paramsIdToPasswordUpdate,
      handlePasswordUpdateClick,
      paramsIdToDelete,
      paramsIdToRestore,
      handleDeleteClick,
      handleConfirmDelete,
      handleRestoreClick,
      handleConfirmRestore,
      downloadCsv,
      selectedFile,
      handleFileChange,
      clearErrorMessages,
      submitFile,
      errorMessages,
      searchName,
      searchEmail,
      searchDeletedStatus,
      clientSystems,
      roleLabel,
      getSearchQuery,
      currentPage,
      totalPages,
      handleChangePage,
      searchUsers,
      searchResetUsers,
      isSearchExpanded,
      topFixArea,
      tableWrapper,
      paginationContainer
    };
  }
};
</script>

<style scoped>
table .btn-cell{
  width: 296px;
  min-width: 296px;
  max-width: 296px;
}

.no-active-user td {
  background-color: #aaa;
}
</style>
